// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leftPanel_UuBtg {
    background: var(--white-background);
    display: inline-flex;
    flex-direction: column;
    gap: 10px;
}

.navTabs_kJdvB {
    display: flex;
    gap: 10px;

    .buttonsContainer_KbDsE {
        overflow: scroll;
        white-space: nowrap;
        /* scrollbar-width: none; 
  -ms-overflow-style: none;  */
    }

    /* .buttonsContainer::-webkit-scrollbar {
  display: none; 
} */
}

.firstPart_yYgyD {
    display: flex;
    flex-direction: row;
    gap: 5px;
}

@media (width<=500px) {
    .navTabs_kJdvB {
        flex-direction: column;
    }

    .firstPart_yYgyD {
        display: flex;
        flex-direction: column;
    }

    .contactStats_VMaKL {
        flex-direction: column;
    }
}

.navTab_vqLfo {
    border: none;
    background: none;
    color: #d0d0d0;
    font-size: 20px;
    white-space: nowrap;
    cursor: pointer;
    border-bottom: 3px solid transparent;
    font-weight: bold;
    transition: all 0.2s ease;
}

.navTab_vqLfo:hover {
    color: var(--334155-color);
}

.navTab_vqLfo.active_bN8Id {
    color: var(--1e293b-color);
}

.searchContainer_lZFyb {
    display: flex;
}

.searchSection_Z1fID {
    width: 100%;
}

.searchBar_JLxXl {
    position: relative;
    height: 36px;
    display: flex;
    align-items: center;
    /* padding: 0 10px; */
    border:1px solid var(--ececf1-border) ;
    border-radius: 6px;
    /* width: 100%; */
    padding: 0px 5px;
    gap: 5px;

    svg {
        width: 24px;
        height: 24px;
    }
}

.searchInput_plQVk {
    outline: none;
    width: 100%;
    padding: 0px 10px;
    border: none;
    font-size: 12px;
    background: transparent;
}



.searchIcon_jvX9R {
    color: var(--94a3b8-color);
    font-size: 12px;
    font-weight: 500;
    background: var(--f0-border);
    border-radius: 4px;
    font-family: monospace;
    width: 26px;
    /* min-width: 24px; */
    height: 20px;
    /* min-height: 20px; */
    display: inline-flex;
    align-items: center;
    justify-content: center;
}


.contentSection_tsBKT {
    /* border: 1px solid #e2e8f0; */
    border-radius: 12px;
    /* overflow: hidden; */
}

.sectionHeader__e00j {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
    background: var(--f5-background);
    border-bottom: 1px solid var(--f1f5f9-border);
    margin-top: 10px;

}


.sectionTitle_hjxON {
    font-size: 13px;
    font-weight: 500;
    color: #828589;
}




.checkbox_kQ4qt {
    margin-right: 12px;
    width: 16px;
    height: 16px;
    accent-color: var(--10b981-background);
}


.documentIcon_cGdu3 {

    margin-right: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 24px;
        height: 24px;
    }
}

.contactInfo_hwEpB {
    flex: 1 1;
}

.documentId_Dbtbe {
    font-weight: 600;
    margin-right: 8px;
    color: var(--1e293b-color);
}

.statusBadge_yZBq1 {
    display: inline-block;
    padding: 3px 8px;
    border-radius: 5px;
    font-size: 9px;
    font-weight: 600;
    margin-right: 8px;
    text-transform: uppercase;
    letter-spacing: 0.025em;
    background-color: var(--_10a37f-background);
    color: var(--white-color);
}

.statusDots_viLIz {
    display: flex;
    align-items: center;
    gap: 4px;

    .statusDot_gxpN_ {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #cbd5e1;

        &:nth-child(2) {
            background-color: #94a3b8;
        }

        &:nth-child(3) {
            background-color: #64748b;
        }

        &:nth-child(4) {
            background-color: #475569;
        }

        &:nth-child(5) {
            background-color: #334155;
        }
    }
}

.status-approved_ZKLLd {
    background: var(--dcfce7-background);
    color: var(--16a34a-color);
}

.documentMeta_ZrmN9,
.contactStats_VMaKL {
    display: flex;
    font-size: 12px;
    color: var(--64748b-color);
    margin-top: 4px;
    line-height: 1.4;
}

.documentMeta_ZrmN9 {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .documentMetaTop_sz4m2,
    .documentMetaBottom_vpVtQ {
        display: flex;
        align-items: center;
        gap: 8px;
        justify-content: flex-end;
    }

    .documentMetaTop_sz4m2 {
        span {
            font-weight: 500;
            font-size: 14px;
            display: inline-flex;
            align-items: center;
            gap: 4px;
        }
    }

    .documentMetaBottom_vpVtQ {
        span {
            font-weight: 500;
            font-size: 12px;
        }
    }

}

.pendingDot_ifBUk {
    color: var(--f59e0b-color);

    font-weight: bold;
}

.contactRightColumn_KWJm7 {
    font-weight: 500;
    color: var(--1e293b-color);
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 10px;

    .thirdPart_em0Tj {
        width: 10px;
    }
}

.contactAmount_tGnxx {
    display: flex;
    flex-direction: column;
    gap: 5px;

    span {
        white-space: nowrap;
        color: #6e6e80
    }

}

.contactAvatar_cGYum {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    margin-right: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: var(--64748b-color);

    svg {
        width: 42px;
        height: 42px;
    }

    img {
        width: 42px;
        height: 42px;
        border-radius: 50%;
    }
}


.overdueText_qeKEp {
    color: var(--ef4444-color);
    font-weight: 600;
}


.messageDafault_zkh6c {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: var(--black-color);
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 14px 10px;

    svg {
        margin: -40px 0px;
    }

    .titleMessage_H4S21 {
        font-size: 18px;
        font-weight: bold;
        margin: 0px 0px;
    }

    .descriptionMessage_DtF8M {
        margin: 10px 0px;
        font-size: 15px;
    }
}

.LeftPanelContainer_kYepV {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
}

.sectionHeaderContainer_YcNf1 {
    display: flex;
    flex-direction: column;
    gap: 10px;
    position: sticky;
    top: 0;
    padding-top: 15px;
    background: var(--white-background);
    padding-top: 15px;
    z-index: 1;
}

.contactItem_QAkU5 {
    display: flex;
    padding: 12px 0px;
    border-bottom: 1px solid var(--ececf1-border);
}

.teamLeftColumn_Zosf6 {
    display: flex;

    .textContainer_Il3kD {
        .topPart_NidqO {
            display: flex;
            gap: 5px;
            align-items: center;
            color: var(--_2-color);

            button {
                border: none;
                background: #FFCF63;
                background-color: #FFCF63;
                border-radius: 4px;
                color: white;
                font-size: 12px;
            }
        }

        .bottomPart_MYKcT {
            display: flex;
            gap: 5px;
            font-size: 12px;
            color: var(--_71-color);
            margin-top: 4px;
            line-height: 1.4;
            align-items: center;

            .clearColor_EpkOA {
                color: #b5b5b5;
            }

            .littlePoint_JvBzp {
                padding: 1.3px;
                border-radius: 100%;
                background-color: var(--_71-color);
            }
        }
    }
}

.btnContactInfoContainer_a_W0y {
    display: flex;
    align-items: center;
    gap: 5px;
    width: 100%;
    justify-content: center;
    pointer-events: auto;

    button {
        border-radius: 999px;

        svg {
            color: var(--969595-fill);
            fill: var(--969595-fill);
        }

        .activeBtn_JzTec {
            color: var(--_10a37f-border);
            fill: var(--_10a37f-border);
        }
    }

    svg {
        width: 20px;
        height: 20px;
    }
}

.progressWrapper_o_Kpf {
    /* margin: 16px 0; */
}

.progressBar_zRqNf {
    width: 100%;
    height: 10px;
    background-color: #c9c9cc;
    border: 1px solid var(--ced4da-border);
    overflow: hidden;
    border-radius: 100px;
    box-sizing: border-box;
    display: flex;
    justify-content: end;
}

.progressFill_qbcXJ {
    height: 100%;
    background-color: var(--_10a37f-background);
    transition: width 0.3s ease;
    border-radius: 2px;
}

.documentsRoutes_HYCso {
    font-weight: bold;
    display: flex;
    gap: 15px;
    padding: 8px 0px;

    svg {
        fill: #b3b3b3
    }

    .firstSpan_QVH4u {
        color: #b3b3b3;

    }
}

.documentsDontFound_veeho {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 50px;
    gap: 25px;

    span {}

    svg {}
}

.documentItem_uaH04 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 15px;

    .left_tSbo4 {
        display: flex;
        align-items: center;
        gap: 15px;

        .textContainer_Il3kD {
            display: flex;
            flex-direction: column;

            .firstSpan_QVH4u {
                color: var(--_6-color)
            }

            .secondSpan_zTg8f {
                color: #c2c2c2
            }
        }

    }


    .right_iECYY {
        display: flex;
        align-items: center;
        gap: 5ps;

        .firstPart_yYgyD {
            color: #9FA3A9;
            align-items: center;

            .textContainer_Il3kD {
                display: flex;
                flex-direction: column;
                font-size: 12px;
                align-items: end;
                color: #667085;

                .clear_Va5Ql {
                    color: #9fa3a9;
                }
            }

            .lessSeparator_zfre9 {
                padding: 0px 10px;
                color: #667085;
            }

            .pointSeparator_f8HBP {
                width: 5px;
                height: 5px;
                border-radius: 50%;
                background-color: #667085;
                /* margin: 0px 5px; */
                /* margin-left:5px; */

            }

            .pointsSeparator_eHJRN {
                padding: 0px 5px;
                color: #667085;
            }

            .barSeparator_D3P31 {
                color: #667085;
                padding: 0px 10px;
                border-right: 1px solid #9fa3a9;
                border-left: 1px solid #9fa3a9;
                height: 20px;

            }
        }

        .secondtPart_loWTm {
            display: flex;
            align-items: center;
            gap: 10px;
        }

        .thirdPart_em0Tj {
            width: 10px;
        }
    }
}

.incomeItemContainer_YcZNG {
    padding: 0px 15px;
}

.incomeItem_eqvwT {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0px;
    border-bottom: 1px solid var(--ececf1-border);

    .left_tSbo4 {
        span {
            font-weight: 500;
        }

    }


    .right_iECYY {
        display: flex;
        align-items: center;
        gap: 5ps;

        .firstPart_yYgyD {
            color: #9FA3A9;
            align-items: center;

            .textContainer_Il3kD {
                display: flex;
                flex-direction: column;
                font-size: 12px;
                align-items: end;
                color: #667085;

                .clear_Va5Ql {
                    color: #9fa3a9;
                }
            }

            .lessSeparator_zfre9 {
                padding: 0px 10px;
                color: #667085;
            }

            .pointSeparator_f8HBP {
                width: 5px;
                height: 5px;
                border-radius: 50%;
                background-color: #667085;
                /* margin: 0px 5px; */
                /* margin-left:5px; */

            }

            .pointsSeparator_eHJRN {
                padding: 0px 5px;
                color: #667085;
            }

            .barSeparator_D3P31 {
                color: #667085;
                padding: 0px 10px;
                border-right: 1px solid #9fa3a9;
                border-left: 1px solid #9fa3a9;
                height: 20px;

            }
        }

        .secondtPart_loWTm {
            display: flex;
            align-items: center;
            gap: 10px;
        }

        .thirdPart_em0Tj {
            width: 10px;
        }
    }
}

.typeContact_vfPFg {
    display: flex;
    background-color: var(--white-background);
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
    padding: 12px 0px 0px 0px;
    gap: 20px;
    width: 100%;
    height: fit-content;
    box-sizing: border-box;
    overflow-x: auto;

    button {
        background-color: transparent;
        cursor: pointer;
        color: var(--_6-color);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
        border-radius: 8px;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
        -ms-border-radius: 8px;
        -o-border-radius: 8px;
        /* border: 1px solid transparent !important; */
        border: none !important;
        /* flex: 1; */
        background-color: transparent;
        max-height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        outline: none;
        gap: 10px;
        padding: 5px 10px;
    }

    .selected_FhLM9 {
        background-color: #f4f4f4;
        /* color: var(--_0d-color); */
        border-radius: 8px;
        border: none !important;
        box-shadow:
            0px 0px 2px 0px var(--_00000008-shadow),
            0px 0px 0px 0px var(--_00000000-shadow),
            0px 0px 0px 0px var(--_00000000-shadow);
    }
}

.statusColor_SsMWg {
    padding: 5px;
    border-radius: 50%;
    position: absolute;
    bottom: 0;
    right: 0;
}

.pointColor_HV6_I {
    /* height: 2px;
    width: 2px; */
    padding: 3.5px;
    border-radius: 100%;
    background-color: #10A37F;
}

.teamRightColumn_F2xOw {
    font-weight: 500;
    color: var(--1e293b-color);
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 10px;

    .firstPart_yYgyD {
        display: flex;
        flex-direction: column;

        .topPart_NidqO {
            display: flex;
            justify-content: end;
            gap: 15px;
            align-items: center;
            color: #8C90A2;
        }

        .bottomPart_MYKcT {
            display: flex;
            gap: 5px;
            align-items: center;
            color: #acacac;

            .blackColor_NeiKB {
                color: var(--_6-color)
            }

            .pointColor_HV6_I {
                color: var(--_6-color)
            }

            button {
                border: none;
                background: #71717a;
                border-radius: 4px;
                color: white;
                font-size: 12px;
            }
        }
    }

    .thirdPart_em0Tj {
        width: 10px;
    }
}

.teamItem_wP1DB {
    display: flex;
    padding: 12px 0px;
    border-bottom: 1px solid var(--ececf1-border);
    justify-content: space-between;
}

.imageProfileDefault_ZN11z {
    padding: 20px;
    background-color: #10A37F;
    border-radius: 100%;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/DashboardComponents/Main/LeftPanel/LeftPanel.module.css"],"names":[],"mappings":"AAAA;IACI,mCAAmC;IACnC,oBAAoB;IACpB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;;IAET;QACI,gBAAgB;QAChB,mBAAmB;QACnB;8BACsB;IAC1B;;IAEA;;GAED;AACH;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,oCAAoC;IACpC,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,sCAAsC;IACtC,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,QAAQ;;IAER;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,uBAAuB;AAC3B;;;;AAIA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,qBAAqB;IACrB,YAAY;IACZ,sBAAsB;IACtB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;;AAGA;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,gCAAgC;IAChC,6CAA6C;IAC7C,gBAAgB;;AAEpB;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;;;;AAKA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,sCAAsC;AAC1C;;;AAGA;;IAEI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,uBAAuB;IACvB,2CAA2C;IAC3C,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;;IAER;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,yBAAyB;;QAEzB;YACI,yBAAyB;QAC7B;;QAEA;YACI,yBAAyB;QAC7B;;QAEA;YACI,yBAAyB;QAC7B;;QAEA;YACI,yBAAyB;QAC7B;IACJ;AACJ;;AAEA;IACI,oCAAoC;IACpC,0BAA0B;AAC9B;;AAEA;;IAEI,aAAa;IACb,eAAe;IACf,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;;IAER;;QAEI,aAAa;QACb,mBAAmB;QACnB,QAAQ;QACR,yBAAyB;IAC7B;;IAEA;QACI;YACI,gBAAgB;YAChB,eAAe;YACf,oBAAoB;YACpB,mBAAmB;YACnB,QAAQ;QACZ;IACJ;;IAEA;QACI;YACI,gBAAgB;YAChB,eAAe;QACnB;IACJ;;AAEJ;;AAEA;IACI,0BAA0B;;IAE1B,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;;IAET;QACI,WAAW;IACf;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;;IAER;QACI,mBAAmB;QACnB;IACJ;;AAEJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,0BAA0B;;IAE1B;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;AACJ;;;AAGA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;;IAElB;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,MAAM;IACN,iBAAiB;IACjB,mCAAmC;IACnC,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,6CAA6C;AACjD;;AAEA;IACI,aAAa;;IAEb;QACI;YACI,aAAa;YACb,QAAQ;YACR,mBAAmB;YACnB,sBAAsB;;YAEtB;gBACI,YAAY;gBACZ,mBAAmB;gBACnB,yBAAyB;gBACzB,kBAAkB;gBAClB,YAAY;gBACZ,eAAe;YACnB;QACJ;;QAEA;YACI,aAAa;YACb,QAAQ;YACR,eAAe;YACf,uBAAuB;YACvB,eAAe;YACf,gBAAgB;YAChB,mBAAmB;;YAEnB;gBACI,cAAc;YAClB;;YAEA;gBACI,cAAc;gBACd,mBAAmB;gBACnB,kCAAkC;YACtC;QACJ;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,uBAAuB;IACvB,oBAAoB;;IAEpB;QACI,oBAAoB;;QAEpB;YACI,yBAAyB;YACzB,wBAAwB;QAC5B;;QAEA;YACI,4BAA4B;YAC5B,2BAA2B;QAC/B;IACJ;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,sCAAsC;IACtC,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,2CAA2C;IAC3C,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,SAAS;IACT,gBAAgB;;IAEhB;QACI;IACJ;;IAEA;QACI,cAAc;;IAElB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,SAAS;;IAET,MAAM;;IAEN,KAAK;AACT;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;;IAElB;QACI,aAAa;QACb,mBAAmB;QACnB,SAAS;;QAET;YACI,aAAa;YACb,sBAAsB;;YAEtB;gBACI;YACJ;;YAEA;gBACI;YACJ;QACJ;;IAEJ;;;IAGA;QACI,aAAa;QACb,mBAAmB;QACnB,QAAQ;;QAER;YACI,cAAc;YACd,mBAAmB;;YAEnB;gBACI,aAAa;gBACb,sBAAsB;gBACtB,eAAe;gBACf,gBAAgB;gBAChB,cAAc;;gBAEd;oBACI,cAAc;gBAClB;YACJ;;YAEA;gBACI,iBAAiB;gBACjB,cAAc;YAClB;;YAEA;gBACI,UAAU;gBACV,WAAW;gBACX,kBAAkB;gBAClB,yBAAyB;gBACzB,qBAAqB;gBACrB,qBAAqB;;YAEzB;;YAEA;gBACI,gBAAgB;gBAChB,cAAc;YAClB;;YAEA;gBACI,cAAc;gBACd,iBAAiB;gBACjB,+BAA+B;gBAC/B,8BAA8B;gBAC9B,YAAY;;YAEhB;QACJ;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;QACb;;QAEA;YACI,WAAW;QACf;IACJ;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,6CAA6C;;IAE7C;QACI;YACI,gBAAgB;QACpB;;IAEJ;;;IAGA;QACI,aAAa;QACb,mBAAmB;QACnB,QAAQ;;QAER;YACI,cAAc;YACd,mBAAmB;;YAEnB;gBACI,aAAa;gBACb,sBAAsB;gBACtB,eAAe;gBACf,gBAAgB;gBAChB,cAAc;;gBAEd;oBACI,cAAc;gBAClB;YACJ;;YAEA;gBACI,iBAAiB;gBACjB,cAAc;YAClB;;YAEA;gBACI,UAAU;gBACV,WAAW;gBACX,kBAAkB;gBAClB,yBAAyB;gBACzB,qBAAqB;gBACrB,qBAAqB;;YAEzB;;YAEA;gBACI,gBAAgB;gBAChB,cAAc;YAClB;;YAEA;gBACI,cAAc;gBACd,iBAAiB;gBACjB,+BAA+B;gBAC/B,8BAA8B;gBAC9B,YAAY;;YAEhB;QACJ;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;QACb;;QAEA;YACI,WAAW;QACf;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,yCAAyC;IACzC,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,yBAAyB;IACzB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;;IAEhB;QACI,6BAA6B;QAC7B,eAAe;QACf,sBAAsB;QACtB,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;QAClB,0BAA0B;QAC1B,uBAAuB;QACvB,sBAAsB;QACtB,qBAAqB;QACrB,8CAA8C;QAC9C,uBAAuB;QACvB,aAAa;QACb,6BAA6B;QAC7B,gBAAgB;QAChB,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,aAAa;QACb,SAAS;QACT,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;QACzB,6BAA6B;QAC7B,kBAAkB;QAClB,uBAAuB;QACvB;;;mDAG2C;IAC/C;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI;iBACa;IACb,cAAc;IACd,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;;IAET;QACI,aAAa;QACb,sBAAsB;;QAEtB;YACI,aAAa;YACb,oBAAoB;YACpB,SAAS;YACT,mBAAmB;YACnB,cAAc;QAClB;;QAEA;YACI,aAAa;YACb,QAAQ;YACR,mBAAmB;YACnB,cAAc;;YAEd;gBACI;YACJ;;YAEA;gBACI;YACJ;;YAEA;gBACI,YAAY;gBACZ,mBAAmB;gBACnB,kBAAkB;gBAClB,YAAY;gBACZ,eAAe;YACnB;QACJ;IACJ;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,6CAA6C;IAC7C,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB","sourcesContent":[".leftPanel {\n    background: var(--white-background);\n    display: inline-flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.navTabs {\n    display: flex;\n    gap: 10px;\n\n    .buttonsContainer {\n        overflow: scroll;\n        white-space: nowrap;\n        /* scrollbar-width: none; \n  -ms-overflow-style: none;  */\n    }\n\n    /* .buttonsContainer::-webkit-scrollbar {\n  display: none; \n} */\n}\n\n.firstPart {\n    display: flex;\n    flex-direction: row;\n    gap: 5px;\n}\n\n@media (width<=500px) {\n    .navTabs {\n        flex-direction: column;\n    }\n\n    .firstPart {\n        display: flex;\n        flex-direction: column;\n    }\n\n    .contactStats {\n        flex-direction: column;\n    }\n}\n\n.navTab {\n    border: none;\n    background: none;\n    color: #d0d0d0;\n    font-size: 20px;\n    white-space: nowrap;\n    cursor: pointer;\n    border-bottom: 3px solid transparent;\n    font-weight: bold;\n    transition: all 0.2s ease;\n}\n\n.navTab:hover {\n    color: var(--334155-color);\n}\n\n.navTab.active {\n    color: var(--1e293b-color);\n}\n\n.searchContainer {\n    display: flex;\n}\n\n.searchSection {\n    width: 100%;\n}\n\n.searchBar {\n    position: relative;\n    height: 36px;\n    display: flex;\n    align-items: center;\n    /* padding: 0 10px; */\n    border:1px solid var(--ececf1-border) ;\n    border-radius: 6px;\n    /* width: 100%; */\n    padding: 0px 5px;\n    gap: 5px;\n\n    svg {\n        width: 24px;\n        height: 24px;\n    }\n}\n\n.searchInput {\n    outline: none;\n    width: 100%;\n    padding: 0px 10px;\n    border: none;\n    font-size: 12px;\n    background: transparent;\n}\n\n\n\n.searchIcon {\n    color: var(--94a3b8-color);\n    font-size: 12px;\n    font-weight: 500;\n    background: var(--f0-border);\n    border-radius: 4px;\n    font-family: monospace;\n    width: 26px;\n    /* min-width: 24px; */\n    height: 20px;\n    /* min-height: 20px; */\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n\n.contentSection {\n    /* border: 1px solid #e2e8f0; */\n    border-radius: 12px;\n    /* overflow: hidden; */\n}\n\n.sectionHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 8px;\n    background: var(--f5-background);\n    border-bottom: 1px solid var(--f1f5f9-border);\n    margin-top: 10px;\n\n}\n\n\n.sectionTitle {\n    font-size: 13px;\n    font-weight: 500;\n    color: #828589;\n}\n\n\n\n\n.checkbox {\n    margin-right: 12px;\n    width: 16px;\n    height: 16px;\n    accent-color: var(--10b981-background);\n}\n\n\n.documentIcon {\n\n    margin-right: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    svg {\n        width: 24px;\n        height: 24px;\n    }\n}\n\n.contactInfo {\n    flex: 1 1;\n}\n\n.documentId {\n    font-weight: 600;\n    margin-right: 8px;\n    color: var(--1e293b-color);\n}\n\n.statusBadge {\n    display: inline-block;\n    padding: 3px 8px;\n    border-radius: 5px;\n    font-size: 9px;\n    font-weight: 600;\n    margin-right: 8px;\n    text-transform: uppercase;\n    letter-spacing: 0.025em;\n    background-color: var(--_10a37f-background);\n    color: var(--white-color);\n}\n\n.statusDots {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n\n    .statusDot {\n        width: 10px;\n        height: 10px;\n        border-radius: 50%;\n        background-color: #cbd5e1;\n\n        &:nth-child(2) {\n            background-color: #94a3b8;\n        }\n\n        &:nth-child(3) {\n            background-color: #64748b;\n        }\n\n        &:nth-child(4) {\n            background-color: #475569;\n        }\n\n        &:nth-child(5) {\n            background-color: #334155;\n        }\n    }\n}\n\n.status-approved {\n    background: var(--dcfce7-background);\n    color: var(--16a34a-color);\n}\n\n.documentMeta,\n.contactStats {\n    display: flex;\n    font-size: 12px;\n    color: var(--64748b-color);\n    margin-top: 4px;\n    line-height: 1.4;\n}\n\n.documentMeta {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n\n    .documentMetaTop,\n    .documentMetaBottom {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        justify-content: flex-end;\n    }\n\n    .documentMetaTop {\n        span {\n            font-weight: 500;\n            font-size: 14px;\n            display: inline-flex;\n            align-items: center;\n            gap: 4px;\n        }\n    }\n\n    .documentMetaBottom {\n        span {\n            font-weight: 500;\n            font-size: 12px;\n        }\n    }\n\n}\n\n.pendingDot {\n    color: var(--f59e0b-color);\n\n    font-weight: bold;\n}\n\n.contactRightColumn {\n    font-weight: 500;\n    color: var(--1e293b-color);\n    font-size: 12px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    .thirdPart {\n        width: 10px;\n    }\n}\n\n.contactAmount {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n\n    span {\n        white-space: nowrap;\n        color: #6e6e80\n    }\n\n}\n\n.contactAvatar {\n    width: 42px;\n    height: 42px;\n    border-radius: 50%;\n    margin-right: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    color: var(--64748b-color);\n\n    svg {\n        width: 42px;\n        height: 42px;\n    }\n\n    img {\n        width: 42px;\n        height: 42px;\n        border-radius: 50%;\n    }\n}\n\n\n.overdueText {\n    color: var(--ef4444-color);\n    font-weight: 600;\n}\n\n\n.messageDafault {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    color: var(--black-color);\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    padding: 14px 10px;\n\n    svg {\n        margin: -40px 0px;\n    }\n\n    .titleMessage {\n        font-size: 18px;\n        font-weight: bold;\n        margin: 0px 0px;\n    }\n\n    .descriptionMessage {\n        margin: 10px 0px;\n        font-size: 15px;\n    }\n}\n\n.LeftPanelContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    width: 100%;\n}\n\n.sectionHeaderContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    position: sticky;\n    top: 0;\n    padding-top: 15px;\n    background: var(--white-background);\n    padding-top: 15px;\n    z-index: 1;\n}\n\n.contactItem {\n    display: flex;\n    padding: 12px 0px;\n    border-bottom: 1px solid var(--ececf1-border);\n}\n\n.teamLeftColumn {\n    display: flex;\n\n    .textContainer {\n        .topPart {\n            display: flex;\n            gap: 5px;\n            align-items: center;\n            color: var(--_2-color);\n\n            button {\n                border: none;\n                background: #FFCF63;\n                background-color: #FFCF63;\n                border-radius: 4px;\n                color: white;\n                font-size: 12px;\n            }\n        }\n\n        .bottomPart {\n            display: flex;\n            gap: 5px;\n            font-size: 12px;\n            color: var(--_71-color);\n            margin-top: 4px;\n            line-height: 1.4;\n            align-items: center;\n\n            .clearColor {\n                color: #b5b5b5;\n            }\n\n            .littlePoint {\n                padding: 1.3px;\n                border-radius: 100%;\n                background-color: var(--_71-color);\n            }\n        }\n    }\n}\n\n.btnContactInfoContainer {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    width: 100%;\n    justify-content: center;\n    pointer-events: auto;\n\n    button {\n        border-radius: 999px;\n\n        svg {\n            color: var(--969595-fill);\n            fill: var(--969595-fill);\n        }\n\n        .activeBtn {\n            color: var(--_10a37f-border);\n            fill: var(--_10a37f-border);\n        }\n    }\n\n    svg {\n        width: 20px;\n        height: 20px;\n    }\n}\n\n.progressWrapper {\n    /* margin: 16px 0; */\n}\n\n.progressBar {\n    width: 100%;\n    height: 10px;\n    background-color: #c9c9cc;\n    border: 1px solid var(--ced4da-border);\n    overflow: hidden;\n    border-radius: 100px;\n    box-sizing: border-box;\n    display: flex;\n    justify-content: end;\n}\n\n.progressFill {\n    height: 100%;\n    background-color: var(--_10a37f-background);\n    transition: width 0.3s ease;\n    border-radius: 2px;\n}\n\n.documentsRoutes {\n    font-weight: bold;\n    display: flex;\n    gap: 15px;\n    padding: 8px 0px;\n\n    svg {\n        fill: #b3b3b3\n    }\n\n    .firstSpan {\n        color: #b3b3b3;\n\n    }\n}\n\n.documentsDontFound {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 50px;\n    gap: 25px;\n\n    span {}\n\n    svg {}\n}\n\n.documentItem {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px 15px;\n\n    .left {\n        display: flex;\n        align-items: center;\n        gap: 15px;\n\n        .textContainer {\n            display: flex;\n            flex-direction: column;\n\n            .firstSpan {\n                color: var(--_6-color)\n            }\n\n            .secondSpan {\n                color: #c2c2c2\n            }\n        }\n\n    }\n\n\n    .right {\n        display: flex;\n        align-items: center;\n        gap: 5ps;\n\n        .firstPart {\n            color: #9FA3A9;\n            align-items: center;\n\n            .textContainer {\n                display: flex;\n                flex-direction: column;\n                font-size: 12px;\n                align-items: end;\n                color: #667085;\n\n                .clear {\n                    color: #9fa3a9;\n                }\n            }\n\n            .lessSeparator {\n                padding: 0px 10px;\n                color: #667085;\n            }\n\n            .pointSeparator {\n                width: 5px;\n                height: 5px;\n                border-radius: 50%;\n                background-color: #667085;\n                /* margin: 0px 5px; */\n                /* margin-left:5px; */\n\n            }\n\n            .pointsSeparator {\n                padding: 0px 5px;\n                color: #667085;\n            }\n\n            .barSeparator {\n                color: #667085;\n                padding: 0px 10px;\n                border-right: 1px solid #9fa3a9;\n                border-left: 1px solid #9fa3a9;\n                height: 20px;\n\n            }\n        }\n\n        .secondtPart {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n        }\n\n        .thirdPart {\n            width: 10px;\n        }\n    }\n}\n\n.incomeItemContainer {\n    padding: 0px 15px;\n}\n\n.incomeItem {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px 0px;\n    border-bottom: 1px solid var(--ececf1-border);\n\n    .left {\n        span {\n            font-weight: 500;\n        }\n\n    }\n\n\n    .right {\n        display: flex;\n        align-items: center;\n        gap: 5ps;\n\n        .firstPart {\n            color: #9FA3A9;\n            align-items: center;\n\n            .textContainer {\n                display: flex;\n                flex-direction: column;\n                font-size: 12px;\n                align-items: end;\n                color: #667085;\n\n                .clear {\n                    color: #9fa3a9;\n                }\n            }\n\n            .lessSeparator {\n                padding: 0px 10px;\n                color: #667085;\n            }\n\n            .pointSeparator {\n                width: 5px;\n                height: 5px;\n                border-radius: 50%;\n                background-color: #667085;\n                /* margin: 0px 5px; */\n                /* margin-left:5px; */\n\n            }\n\n            .pointsSeparator {\n                padding: 0px 5px;\n                color: #667085;\n            }\n\n            .barSeparator {\n                color: #667085;\n                padding: 0px 10px;\n                border-right: 1px solid #9fa3a9;\n                border-left: 1px solid #9fa3a9;\n                height: 20px;\n\n            }\n        }\n\n        .secondtPart {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n        }\n\n        .thirdPart {\n            width: 10px;\n        }\n    }\n}\n\n.typeContact {\n    display: flex;\n    background-color: var(--white-background);\n    border-radius: 6px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n    padding: 12px 0px 0px 0px;\n    gap: 20px;\n    width: 100%;\n    height: fit-content;\n    box-sizing: border-box;\n    overflow-x: auto;\n\n    button {\n        background-color: transparent;\n        cursor: pointer;\n        color: var(--_6-color);\n        font-family: Inter;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 24px;\n        border-radius: 8px;\n        -webkit-border-radius: 8px;\n        -moz-border-radius: 8px;\n        -ms-border-radius: 8px;\n        -o-border-radius: 8px;\n        /* border: 1px solid transparent !important; */\n        border: none !important;\n        /* flex: 1; */\n        background-color: transparent;\n        max-height: 40px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        outline: none;\n        gap: 10px;\n        padding: 5px 10px;\n    }\n\n    .selected {\n        background-color: #f4f4f4;\n        /* color: var(--_0d-color); */\n        border-radius: 8px;\n        border: none !important;\n        box-shadow:\n            0px 0px 2px 0px var(--_00000008-shadow),\n            0px 0px 0px 0px var(--_00000000-shadow),\n            0px 0px 0px 0px var(--_00000000-shadow);\n    }\n}\n\n.statusColor {\n    padding: 5px;\n    border-radius: 50%;\n    position: absolute;\n    bottom: 0;\n    right: 0;\n}\n\n.pointColor {\n    /* height: 2px;\n    width: 2px; */\n    padding: 3.5px;\n    border-radius: 100%;\n    background-color: #10A37F;\n}\n\n.teamRightColumn {\n    font-weight: 500;\n    color: var(--1e293b-color);\n    font-size: 12px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    .firstPart {\n        display: flex;\n        flex-direction: column;\n\n        .topPart {\n            display: flex;\n            justify-content: end;\n            gap: 15px;\n            align-items: center;\n            color: #8C90A2;\n        }\n\n        .bottomPart {\n            display: flex;\n            gap: 5px;\n            align-items: center;\n            color: #acacac;\n\n            .blackColor {\n                color: var(--_6-color)\n            }\n\n            .pointColor {\n                color: var(--_6-color)\n            }\n\n            button {\n                border: none;\n                background: #71717a;\n                border-radius: 4px;\n                color: white;\n                font-size: 12px;\n            }\n        }\n    }\n\n    .thirdPart {\n        width: 10px;\n    }\n}\n\n.teamItem {\n    display: flex;\n    padding: 12px 0px;\n    border-bottom: 1px solid var(--ececf1-border);\n    justify-content: space-between;\n}\n\n.imageProfileDefault {\n    padding: 20px;\n    background-color: #10A37F;\n    border-radius: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"leftPanel": `leftPanel_UuBtg`,
	"navTabs": `navTabs_kJdvB`,
	"buttonsContainer": `buttonsContainer_KbDsE`,
	"firstPart": `firstPart_yYgyD`,
	"contactStats": `contactStats_VMaKL`,
	"navTab": `navTab_vqLfo`,
	"active": `active_bN8Id`,
	"searchContainer": `searchContainer_lZFyb`,
	"searchSection": `searchSection_Z1fID`,
	"searchBar": `searchBar_JLxXl`,
	"searchInput": `searchInput_plQVk`,
	"searchIcon": `searchIcon_jvX9R`,
	"contentSection": `contentSection_tsBKT`,
	"sectionHeader": `sectionHeader__e00j`,
	"sectionTitle": `sectionTitle_hjxON`,
	"checkbox": `checkbox_kQ4qt`,
	"documentIcon": `documentIcon_cGdu3`,
	"contactInfo": `contactInfo_hwEpB`,
	"documentId": `documentId_Dbtbe`,
	"statusBadge": `statusBadge_yZBq1`,
	"statusDots": `statusDots_viLIz`,
	"statusDot": `statusDot_gxpN_`,
	"status-approved": `status-approved_ZKLLd`,
	"documentMeta": `documentMeta_ZrmN9`,
	"documentMetaTop": `documentMetaTop_sz4m2`,
	"documentMetaBottom": `documentMetaBottom_vpVtQ`,
	"pendingDot": `pendingDot_ifBUk`,
	"contactRightColumn": `contactRightColumn_KWJm7`,
	"thirdPart": `thirdPart_em0Tj`,
	"contactAmount": `contactAmount_tGnxx`,
	"contactAvatar": `contactAvatar_cGYum`,
	"overdueText": `overdueText_qeKEp`,
	"messageDafault": `messageDafault_zkh6c`,
	"titleMessage": `titleMessage_H4S21`,
	"descriptionMessage": `descriptionMessage_DtF8M`,
	"LeftPanelContainer": `LeftPanelContainer_kYepV`,
	"sectionHeaderContainer": `sectionHeaderContainer_YcNf1`,
	"contactItem": `contactItem_QAkU5`,
	"teamLeftColumn": `teamLeftColumn_Zosf6`,
	"textContainer": `textContainer_Il3kD`,
	"topPart": `topPart_NidqO`,
	"bottomPart": `bottomPart_MYKcT`,
	"clearColor": `clearColor_EpkOA`,
	"littlePoint": `littlePoint_JvBzp`,
	"btnContactInfoContainer": `btnContactInfoContainer_a_W0y`,
	"activeBtn": `activeBtn_JzTec`,
	"progressWrapper": `progressWrapper_o_Kpf`,
	"progressBar": `progressBar_zRqNf`,
	"progressFill": `progressFill_qbcXJ`,
	"documentsRoutes": `documentsRoutes_HYCso`,
	"firstSpan": `firstSpan_QVH4u`,
	"documentsDontFound": `documentsDontFound_veeho`,
	"documentItem": `documentItem_uaH04`,
	"left": `left_tSbo4`,
	"secondSpan": `secondSpan_zTg8f`,
	"right": `right_iECYY`,
	"clear": `clear_Va5Ql`,
	"lessSeparator": `lessSeparator_zfre9`,
	"pointSeparator": `pointSeparator_f8HBP`,
	"pointsSeparator": `pointsSeparator_eHJRN`,
	"barSeparator": `barSeparator_D3P31`,
	"secondtPart": `secondtPart_loWTm`,
	"incomeItemContainer": `incomeItemContainer_YcZNG`,
	"incomeItem": `incomeItem_eqvwT`,
	"typeContact": `typeContact_vfPFg`,
	"selected": `selected_FhLM9`,
	"statusColor": `statusColor_SsMWg`,
	"pointColor": `pointColor_HV6_I`,
	"teamRightColumn": `teamRightColumn_F2xOw`,
	"blackColor": `blackColor_NeiKB`,
	"teamItem": `teamItem_wP1DB`,
	"imageProfileDefault": `imageProfileDefault_ZN11z`
};
export default ___CSS_LOADER_EXPORT___;
